import { i18n } from "@/plugins/i18n";
import axios from "axios";

import { PlanService } from "../services/plan.service";


import { sortAlphanum } from "@/alphanumericSort";

const state = {
  claimsPlan: null,
  plan: null,
  settings: null,
  brokerId: null,
  userEmployers: [],
  navbarOpen: true,
  language: null,
  plans: null,
  messages: [],
  languages: [
    { flag: "us", language: "en", title: "English" },
    { flag: "fr", language: "fr", title: "Français" },
  ],
  winZones: [
    {
      offset: -480,
      id: "Pacific Standard Time",
      supportsDaylightSavingTime: true,
      offsetText: "-8:00",
    },
    {
      offset: -420,
      id: "Mountain Standard Time",
      supportsDaylightSavingTime: true,
      offsetText: "-7:00",
    },
    {
      offset: -360,
      id: "Central Standard Time",
      supportsDaylightSavingTime: true,
      offsetText: "-6:00",
    },
    {
      offset: -300,
      id: "Eastern Standard Time",
      supportsDaylightSavingTime: true,
      offsetText: "-5:00",
    },
    {
      offset: -240,
      id: "Atlantic Standard Time",
      supportsDaylightSavingTime: true,
      offsetText: "-4:00",
    },
    {
      offset: -210,
      id: "Newfoundland Standard Time",
      supportsDaylightSavingTime: true,
      offsetText: "-3:-30",
    },
  ],
};

const getters = {
  plan: (state) => {
    if (state.plan) return state.plan;
    const plan = PlanService.getPlan();
    if (localStorage.rememberPlan && plan) {
      try {
        state.plan = plan;
        return state.plan;
      } catch {
        return null;
      }
    }
  },
  claimsPlan: (state) => {
    return state.claimsPlan;
  },
  settings: (state) => {
    return state.settings;
  },
  brokerId: (state) => {
    return state.brokerId;
  },
  userEmployers: (state) => {
    return state.userEmployers;
  },
  navbarOpen: (state) => {
    return state.navbarOpen;
  },
  language: (state) => {
    //console.log("commpon store: get language: ", state.language)
    return state.language;
  },
  plans: (state) => {
    return state.plans;
  },
  messages: (state) => {
    return state.messages;
  },
  languages: (state) => {
    return state.languages;
  },
  winZones: (state) => {
    return state.winZones;
  },
};

const actions = {
  setPlanId({ commit }, id) {
    //console.log("SET PLAN: ", value)
    commit("setPlanId", id);
  },
  setPlan({ commit }, value) {
    //console.log("SET PLAN: ", value)
    commit("setPlan", value);
  },
  setClaimsPlan({ commit }, value) {
    //console.log("SET PLAN: ", value)
    commit("setClaimsPlan", value);
  },
  setPlans({ commit }, value) {
    //console.log("SET PLAN: ", value)
    commit("setPlans", value);
  },
  setLanguage({ commit }, value) {
    commit("setLanguage", value);
    axios.defaults.headers.common["Accept-Language"] = value.language;
  },
  setLanguageFromUrl({ commit }, value) {
    // console.log("common: set lang from url: ", value)
    if (value === "en")
      commit("setLanguage", { language: "en", title: "English" });
    else if (value === "fr")
      commit("setLanguage", { language: "fr", title: "Français" });
  },
  getLanguage({ commit }) {
    //console.log("common: get lang: ", commit.language)

    return commit.language;
  },
  setSettings({ commit }, value) {
    commit("setSettings", value);
  },
  setBrokerId({ commit }, value) {
    commit("setBrokerId", value);
  },
  setEmployers({ commit }, value) {
    commit("setEmployers", value);
  },
  setNavbarOpen({ commit }, value) {
    commit("setNavbarOpen", value);
  },
};

const mutations = {
  setPlanId(state, id) {
    let value = state.plans.find(o=>o.Id === id);
    if (value!==null && value !== undefined) {
      
      localStorage.selectedPlan = JSON.stringify(value);
      state.plan = value;
    }
    state.claimsPlan = null;
  },
  setPlan(state, value) {
    // if (localStorage.rememberPlan) {
    localStorage.selectedPlan = JSON.stringify(value);
    // }
    state.plan = value;
    state.claimsPlan = null;
  },
  setClaimsPlan(state, value) {
    state.claimsPlan = value;
  },
  setPlans(state, value) {
    state.plans = value.sort((a, b) => {
      const translatedA =  a.Translations.filter(
          (o) => o.LanguageCode === state.language.language
        )[0].Name;
      const translatedB = b.Translations.filter(
          (o) => o.LanguageCode === state.language.language
        )[0].Name;
        // console.log(translatedA, translatedB);
      return sortAlphanum(translatedA, translatedB);
    });
  },
  setSettings(state, value) {
    state.settings = value;
  },
  setBrokerId(state, value) {
    state.brokerId = value;
  },
  setEmployers(state, value) {
    state.userEmployers = value;
  },
  setNavbarOpen(state, value) {
    state.navbarOpen = value;
  },
  setLanguage(state, value) {
    // console.log("common set language: ", value, value.language)
    state.language = value;
    i18n.locale = value.language;
    window.localStorage[`language`] = JSON.stringify(value);
    document.title = i18n.t("globals.app_title");
  },
};

export const common = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
